import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cart"
export default class extends Controller {
  static values = {openOnLoad: {type: Boolean, default: false}}
  static targets = ["toggle"]

  connect() {
    if (this.openOnLoadValue) {
      this.openOnLoadValue = false
      this.toggleTarget.click()
    }
  }
}
